{"id":"FooterSocialLinks","prefabs":{"default":{"children":[{"component":"FooterSocialLinks","options":"options:*"}]}}}